import dayjs from 'dayjs';
import getCategoryParameters from './getCategoryParameters';

export default function getArticlesParameters(article) {
  const categoryParameters = getCategoryParameters(article.category);

  return {
    ...categoryParameters,
    slug: article.slug || null,
    createdAt: article.createdAt
      ? dayjs(article.createdAt).format('YYYYMMDD') : '00000000',
    id: article.id,
  };
}
